const form = document.querySelector('.object-detail-form');
if (form) {
  form.addEventListener('submit', e => {
    form.parentNode.classList.add('saving');
    setTimeout(() => form.parentNode.classList.add('show-animation'), 0);
  });
}
